<div class="ac__tag-row">
  @if (assetType()) {
    <asset-type-tag [assetType]="assetType()" />
  }
</div>

<div class="ac__title" [title]="title()">{{ title() }}</div>
<p class="ac__desc">{{ description() }}</p>

<div class="ac__attrs">
  <asset-access-type [accessLevel]="asset().access" />

  <asset-trust-badge
    [isAssetCard]="true"
    [isGovernanceVerified]="asset().governance_verified"
    [isRaiVerified]="asset().responsible_ai_verified"
    [isVerificationInProgress]="asset().verification_in_progress"
  />
</div>

<div class="ac__sector-row">
  @if (asset().sector_name) {
    <span class="ac__attr ac__attr--sector">
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="flex-shrink: 0"
      >
        <path
          d="M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.3.3 0 0 1 .574.1l3.726 6.846A.7.7 0 0 1 14.97 10z"
        />
        <rect x="14" y="14" width="6" height="6" rx="1" />
        <circle cx="6" cy="17" r="3" />
      </svg>
      <span class="ac__sector-label" [title]="asset().sector_name">{{ asset().sector_name }}</span>
    </span>
  }
  @if (regionsText()) {
    <span class="ac__attr ac__attr--sector">
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="flex-shrink: 0"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path
          d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
        />
      </svg>
      <span class="ac__sector-label" [title]="">{{ regionsText() }}</span>
    </span>
  }
</div>

@if (asset().themes.length) {
  <div class="ac__themes">
    @for (theme of asset().themes; track theme) {
      <span class="ac__theme-chip">{{ theme }}</span>
    }
  </div>
}

<div class="ac__footer">
  <div class="ac__stats">
    <span class="ac__stat">
      <ng-icon name="tablerEye" size="11px" />
      {{ asset().view_count }}
    </span>
    <span class="ac__stat-sep">·</span>
    <span class="ac__stat">
      <ng-icon name="tablerDownload" size="11px" />
      {{ downloadCountText() }}
    </span>
  </div>
  <div class="ac__actions">
    @if (assetType() === 'Dataset') {
      <asset-download-button
        [isIconButton]="true"
        [hasAccess]="asset().current_user_has_access"
        [hasDownload]="asset().download_status === 'READY'"
        [assetId]="id()"
        [assetName]="asset().asset_name"
        [ownerName]="asset().owner_name"
        [ownerEmail]="asset().owner_email"
      />
    } @else if (assetType() === 'AI Product') {
      <asset-launch-button
        [assetName]="asset().asset_name"
        [isIconButton]="true"
        [hasAccess]="asset().current_user_has_access"
        [assetId]="asset().asset_id"
        [productLink]="asset().location_uri"
        [ownerName]="asset().owner_name"
        [ownerEmail]="asset().owner_email"
      />
    }
    <button
      class="ac__action-btn"
      [class.ac__action-btn--saved]="isBookmarked()"
      type="button"
      [attr.data-tooltip]="isBookmarked() ? 'Unsave' : 'Save'"
      (click)="handleBookmarkButtonClick($event)"
      [disabled]="isBookmarkButtonLoading()"
    >
      @if (assetService.listAllBookmarks.isLoading()) {
        <loader size="14px" />
      } @else {
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          [attr.fill]="isBookmarked() ? 'currentColor' : 'none'"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
      }
    </button>
  </div>
</div>
